import { createFileRoute } from '@tanstack/react-router';
import { LandingPage } from '@/components/marketing/LandingPage';
import { MarketingShell } from '@/components/marketing/MarketingShell';

/**
 * Landing pública (`/`) — Slice G.
 *
 * Vive bajo el layout `_public.tsx` (creado por Slice H — render `<Outlet/>`).
 * Mientras Slice H no haya mergeado, esta ruta envuelve la página en su propia
 * `MarketingShell` para que se vea standalone. Cuando la layout exista, las dos
 * shells van a anidar — eso es cosmético (no rompe nada) y se resuelve cuando
 * H decida si su layout exporta o no MarketingShell.
 */
export const Route = createFileRoute('/_public/')({
  component: LandingRoute,
});

function LandingRoute(): JSX.Element {
  return (
    <MarketingShell currentPath="/">
      <LandingPage />
    </MarketingShell>
  );
}
